import styles from './styles.module.scss';

export const cardErrorClasses = {
  cardClassName: styles.cardError,
  titleClassName: styles.cardErrorTitle,
  labelClassName: styles.cardErrorLabel,
  buttonClassName: styles.cardErrorButton
};
